<footer class="footer" [ngClass]="{ 'footer-login': isLogin }">
  <app-logo [view]="view"></app-logo>

  <div class="info">
    <p>&copy; {{ "FOOTER.INFO-COCA" | translate }}</p>
  </div>
</footer>
